import { API_URL } from '../../../configs/services/services.config';

export const URL = {
  postSignallerReport: `${API_URL}/signaller/case`,
  getPublicKey: `${API_URL}/signaller/public-key`,
  postEmail: `${API_URL}/signaller/email`,
  postEncryptPdf: `${API_URL}/signaller/encrypt-pdf`,
  getSubjects: `${API_URL}/signaller/subjects`,
  getSignalerCase: `${API_URL}/signaller/case`,
  getComments: `${API_URL}/signaller/comments`,
  postComments: `${API_URL}/signaller/comments`,
} as const;
